export default "__VITE_ASSET__BL1xN1l3__"